function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 10,
  cy: 10,
  r: 10,
  fill: "#FFC369"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M9.11859 13C9.05733 12.9998 8.99677 12.9871 8.94066 12.9627C8.88455 12.9384 8.8341 12.9028 8.79245 12.8583L6.6211 10.5689C6.53994 10.4832 6.49646 10.369 6.50023 10.2515C6.504 10.1339 6.55471 10.0227 6.64121 9.94229C6.72771 9.86184 6.84291 9.81874 6.96147 9.82248C7.08003 9.82621 7.19223 9.87648 7.2734 9.96221L9.11413 11.9062L12.8715 7.83222C12.9097 7.78516 12.9571 7.74632 13.0109 7.71809C13.0648 7.68986 13.1238 7.67283 13.1845 7.66805C13.2452 7.66328 13.3063 7.67085 13.3639 7.69032C13.4216 7.70978 13.4746 7.74071 13.5198 7.78123C13.5649 7.82174 13.6012 7.87097 13.6265 7.9259C13.6517 7.98082 13.6654 8.04029 13.6666 8.10063C13.6678 8.16098 13.6566 8.22094 13.6335 8.27682C13.6105 8.33271 13.5762 8.38334 13.5328 8.42561L9.44921 12.8539C9.40795 12.8992 9.35767 12.9356 9.30155 12.9607C9.24542 12.9859 9.18465 12.9992 9.12306 13H9.11859Z",
  fill: "white"
});

var SvgOk = function SvgOk(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgOk, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ok.694c6e51.svg";
export { ForwardRef as ReactComponent };